import { useSearchParam } from 'react-use';

/**
 * Hook for testing purposes only.
 *
 * Returns `true` if in `development` environment and the `testEmptyCollections`
 * query parameter is set to `true`.
 */
export function useTestEmptyCollections(): boolean {
  const testEmpty = useSearchParam('testEmptyCollections');
  const testEmptyCollections =
    testEmpty && process.env.NODE_ENV === 'development'
      ? Boolean(JSON.parse(testEmpty))
      : false;
  return testEmptyCollections;
}
